import { render, staticRenderFns } from "./Zipolite.vue?vue&type=template&id=1b03d80b&lang=pug&"
import script from "./Zipolite.vue?vue&type=script&lang=ts&"
export * from "./Zipolite.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports